import { SizeVariant } from 'src/types';
import { toHexColor } from './colorUtils';
import { isUndefinedOrNull } from './commonUtils';

const assetsBaseUrl = 'https://sports.cbsimg.net/fly/images/';

export function getAvatarSize(size: SizeVariant): number {
  switch (size) {
    case 'small':
      return 24;
    case 'large':
      return 48;
    case 'extra-large':
      return 60;
    case 'medium':
    default:
      return 36; // Default size
  }
}

export function getLogoSize(size?: SizeVariant): number {
  switch (size) {
    case 'small':
      return 20;
    case 'large':
      return 100;
    case 'extra-large':
      return 142;
    case 'medium':
    default:
      return 60; // Default size
  }
}

export function getCompanyLogoSize(size: SizeVariant): number {
  switch (size) {
    case 'small':
      return 20;
    case 'large':
      return 48;
    case 'extra-large':
      return 60;
    case 'medium':
    default:
      return 34; // Default size
  }
}

// TODO: MOVE TO COLOR UTILS
export const prependHashToColor = (color: string) => toHexColor({ color });

export function getBackgroundStyle(teamColors: string[]): string {
  return teamColors.length === 1
    ? `linear-gradient(90deg, rgba(0, 0, 0, 0.00) 49.88%, rgba(0, 0, 0, 0.25) 100%), ${prependHashToColor(teamColors[0])}`
    : `linear-gradient(90deg, rgba(0, 0, 0, 0.00) 49.88%, rgba(0, 0, 0, 0.25) 100%), linear-gradient(90deg, ${prependHashToColor(teamColors[0])} 0%, ${prependHashToColor(
        teamColors[1],
      )} 100%)`;
}

const logoVariants = {
  light: 'light',
  dark: 'alt',
};

export function getTeamLogo(teamId: string, variant: keyof typeof logoVariants = 'light'): string {
  if (!Boolean(teamId)) {
    return '';
  }
  return `${assetsBaseUrl}team-logos/${logoVariants[variant] ?? logoVariants.light}/${teamId}.svg`;
}

export function getLeagueLogo(leagueId: number | string): string {
  if (!Boolean(leagueId)) {
    return '';
  }
  return `${assetsBaseUrl}league-logos/${leagueId.toString()}.svg`;
}

export function getPlayerAvatar(playerId: string | number, size: number = 60): string {
  if (!Boolean(playerId)) {
    return '';
  }
  return `https://sportshub.cbsistatic.com/i/sports/player/headshot/${playerId.toString()}.png?width=${size}`;
}

const bookLogoBaseUrl = `${assetsBaseUrl}books/`;
const bookIconBaseUrl = `${assetsBaseUrl}books-icons/`;

type BookLogoArgs = {
  bookId: string | number;
  variant?: 'light' | 'dark';
};

export function getBookLogo({ bookId, variant = 'light' }: BookLogoArgs): string {
  if (isUndefinedOrNull(bookId)) {
    return undefined;
  }
  const logo = `${bookId.toString()}.svg`;
  switch (variant) {
    case 'light':
      return `${bookLogoBaseUrl}${variant}/${logo}?v=1`;
    default:
      return `${bookLogoBaseUrl}${logo}?v=1`;
  }
}

export function getBookIcon({ bookId, variant = 'light' }: BookLogoArgs): string {
  if (!Boolean(bookId)) {
    return '';
  }
  const logo = `${bookId.toString()}.svg`;
  switch (variant) {
    case 'light':
      return `${bookIconBaseUrl}${variant}/${logo}?v=1`;
    default:
      return `${bookIconBaseUrl}${logo}?v=1`;
  }
}
